import { FETCH_DOCUMENT_STATUS_CODE } from "constants/ActionTypes";
import { INITIAL_STATE } from "constants/AppConstants";

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_DOCUMENT_STATUS_CODE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
